import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { environment } from 'environments/environment';
import { ContentType } from '@repositories/models';

@Injectable({ providedIn: 'root' })
export class ContentTypeService {
    /**
     * 
     * @param _http 
     */
    constructor(private _http: HttpClient){}

    /**
     * Get all Content Types
     * @returns 
     */
    getAll() {
        return this._http.get<ContentType[]>(`${environment.repositoriesApiUrl}/api/content-type`);
      }
}
